namespace MACRAIL.Validation {

/**
 * Easy validation for form fields.
 */
export class RequiredValidator implements IValidator {

    private opts: any;

    constructor (opts: any) {
        this.opts = opts || {};

        if (!this.opts.message) {
            this.opts.message = 'Please enter a value';
        }
    }

    public validate(value: any) {
        let opts = this.opts;

        let messages: IValidatorMessage[] = [];

        if (value === undefined || value === '') {
            messages.push({
                'slug': 'required',
                'status': 'error',
                'message': this.opts.message,
            });
        }

        return messages;
    }
}

}
